module.exports = __webpack_public_path__ + "static/media/fitness-class-2.cbbc0647.jpeg";